
import { mapState } from 'vuex'
import { Cms } from '@/helpers/cms'
import AgbPopup from '@/components/ui/agb/AgbPopup.vue'
import NotificationsPopup from '@/components/merchant/NotificationsPopup.vue'

export default {
  components: {
    NotificationsPopup,
    AgbPopup
  },
  data () {
    return {
      tocPopup: {
        content: '',
        title: '',
        validFrom: undefined,
        changes: undefined
      },
      showTocDialog: false,
      merchantNotificationPopups: []
    }
  },

  computed: {
    ...mapState('customer', {
      customer: state => state.customer,
      merchantAddress: state => state.merchantAddress,
      readNotificationPopupIds: state => state.merchant?.readNotificationPopupIds
    })

  },
  mounted () {
    const cms = new Cms(this.$axios)
    setTimeout(async () => {
      try {
        await this.reloadAgpPopup(cms)
        await this.reloadMerchantPopups(cms)
      } catch (e) {
        console.error(e)
      }
    }, 3000)
  },
  methods: {

    async reloadAgpPopup (cms) {
      if (!this.$auth.loggedIn) {
        return
      }
      const { locale } = this.$i18n
      const { data: toc } = await cms.get(this.$config.cmsBaseURL + '/api/agb',
        {
          params: {
            locale,
            populate: '*'
          }
        }
      )

      if (toc) {
        this.tocPopup.title = toc.attributes?.title
        this.tocPopup.content = toc.attributes?.content
        this.tocPopup.changes = toc.attributes?.changes?.content
        this.tocPopup.validFrom = toc.attributes?.validFrom
      }

      if (this.customer?.merchantProfileCompleted && this.tocPopup.validFrom) {
        if (this.customer?.tacAcceptedAt) {
          const validFrom = Date.parse(this.tocPopup.validFrom)
          const tacAcceptedAt = Date.parse(this.customer?.tacAcceptedAt)
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          const todayTime = today.getTime()

          const validFromOrToday = validFrom > todayTime ? todayTime : validFrom

          if (validFrom && tacAcceptedAt) {
            this.showTocDialog = validFromOrToday > tacAcceptedAt
          }
        } else {
          // this case should not happen in practice but showing the dialog in this case is the safest option
          this.showTocDialog = true
        }
      }
    },

    async reloadMerchantPopups (cms) {
      if (!this.$auth.loggedIn) {
        // console.log('Not logged in ... not reloading merchant popups')
        return
      }

      if (!this.customer?.merchantProfileCompleted) {
        return
      }

      const { locale } = this.$i18n

      const notificationLocale = this.merchantAddress.notificationLocale
        ? this.merchantAddress.notificationLocale
        : locale

      const { data: merchantNotificationPopups } = await cms.get(this.$config.cmsBaseURL + '/api/merchant-notification-popups',
        {
          params: {
            locale: notificationLocale,
            populate: '*'
          }
        }
      )

      const merchantCreatedAt = Date.parse(this.customer?.createdAt)

      this.merchantNotificationPopups = merchantNotificationPopups
        .filter((popup) => {
          const validFrom = Date.parse(popup.attributes.validFrom)

          if (validFrom < merchantCreatedAt) {
            return false
          }

          return !this.readNotificationPopupIds.includes(popup.id)
        })
        .sort(function (a, b) {
          return new Date(a.attributes?.validFrom) - new Date(b.attributes?.validFrom)
        })
    }
  }
}
